import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';

export const COLUMNS = () => [
    {
        label: 'URL',
        key: 'unique_url_slug',
        data: 'unique_url_slug',
        sortType: 'string',
        cellSize: 'minmax(200px, 2fr)',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <span className="text-wrap">{data}</span>;
        },
    },
    {
        label: 'Clicks',
        key: 'total_slug_clicks',
        data: 'total_slug_clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <span className="wripe">{numeral(data).format('0 a')}</span>;
        },
    },
    {
        label: 'Impressions',
        key: 'total_slug_impressions',
        data: 'total_slug_impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <span className="wripe">{numeral(data).format('0 a')}</span>;
        },
    },
];
